import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "site-widget-container"
}
const _hoisted_2 = {
  key: 0,
  class: "site-widget"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 3,
  class: "container-tiles"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderWidget = _resolveComponent("HeaderWidget")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_NoData = _resolveComponent("NoData")!
  const _component_Tile = _resolveComponent("Tile")!
  const _component_ElevatedCard = _resolveComponent("ElevatedCard")!

  return (_openBlock(), _createBlock(_component_ElevatedCard, {
    widthType: _ctx.WidthType.third,
    class: "container-widget"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_HeaderWidget, {
        iconUrl: _ctx.loadIcon,
        subtitle: _ctx.$t('outPreventiveWidget.subtitle'),
        title: _ctx.widgetTitle,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateTo(_ctx.EtatsTravaux.aRealiser)))
      }, null, 8, ["iconUrl", "subtitle", "title"]),
      (_ctx.widget)
        ? (_openBlock(), _createBlock(_component_ReglePastille, {
            key: 0,
            cle: "dashboard.widgetPerimetreCommun"
          }))
        : _createCommentVNode("", true),
      (_ctx.widget)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.widget.sites == null || _ctx.widget.sites.length > 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('multisites')), 1))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.widget.sites, (site) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: site.id,
                    class: "site-widget"
                  }, [
                    _createTextVNode(_toDisplayString(site.description) + " ", 1),
                    (site.id !== _ctx.widget.sites[_ctx.widget.sites.length - 1].id)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, ", "))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
          ]))
        : _createCommentVNode("", true),
      (
                !_ctx.isLoading &&
                !_ctx.getPreventiveOutData.nbEnCours &&
                !_ctx.getPreventiveOutData.nbARealiser &&
                !_ctx.getPreventiveOutData.nbRealisees
            )
        ? (_openBlock(), _createBlock(_component_NoData, {
            key: 2,
            class: "no-data",
            textNoData: "widget.preventive.noData"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_Tile, {
              isLoading: _ctx.isLoading,
              titleInBold: _ctx.$t('outPreventiveWidget.nbARealiser'),
              titleNotBold: _ctx.$t('outPreventiveWidget.intervention', _ctx.getPreventiveOutData.nbARealiser),
              value: _ctx.getPreventiveOutData.nbARealiser,
              class: "tile",
              color: "--a-realiser",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateTo(_ctx.EtatsTravaux.aRealiser)))
            }, null, 8, ["isLoading", "titleInBold", "titleNotBold", "value"]),
            _createVNode(_component_Tile, {
              isLoading: _ctx.isLoading,
              titleInBold: _ctx.$t('outPreventiveWidget.nbEnCours'),
              titleNotBold: _ctx.$t('outPreventiveWidget.intervention', _ctx.getPreventiveOutData.nbEnCours),
              value: _ctx.getPreventiveOutData.nbEnCours,
              class: "tile",
              color: "--en-cours",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateTo(_ctx.EtatsTravaux.enCours)))
            }, null, 8, ["isLoading", "titleInBold", "titleNotBold", "value"]),
            _createVNode(_component_Tile, {
              isLoading: _ctx.isLoading,
              titleInBold: _ctx.$t('outPreventiveWidget.nbRealisees', _ctx.getPreventiveOutData.nbRealisees),
              titleNotBold: _ctx.$t('outPreventiveWidget.intervention', _ctx.getPreventiveOutData.nbRealisees),
              value: _ctx.getPreventiveOutData.nbRealisees,
              class: "tile",
              color: "--fait",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigateTo(_ctx.EtatsTravaux.realise)))
            }, null, 8, ["isLoading", "titleInBold", "titleNotBold", "value"])
          ]))
    ]),
    _: 1
  }, 8, ["widthType"]))
}